<template>
    <div
        class="bg-white mt-3 p-3 activity-type-create activity-category-view col-12"
    >
        <b-spinner v-if="loading" small></b-spinner>
        <ol>
            <li v-for="link in links" :key="link.id">
                <b-button
                    @click="$emit('change-activity', link.id)"
                    variant="link"
                >
                    {{
                        `${link.type.name} Ref: ${link.reference_no}`
                    }}</b-button
                >
            </li>
        </ol>
    </div>
</template>
<script>
export default {
    name: 'activityLinks',
    data() {
        return {
            links: [],
            loading: false,
        }
    },
    props: ['order'],
    computed: {},
    watch: {},
    mounted() {
        this.populateLinks()
    },
    methods: {
        async populateLinks() {
            try {
                this.loading = true

                for (const link of this.order.secondary_orders) {
                    this.links.push(
                        await this.$store.dispatch(
                            'orders/fetchByIdDirect',
                            link.secondary_order_id
                        )
                    )
                }
                for (const link of this.order.primary_orders) {
                    this.links.push(
                        await this.$store.dispatch(
                            'orders/fetchByIdDirect',
                            link.primary_order_id
                        )
                    )
                }
            } catch (err) {
                console.log('err', err)
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
<style></style>
